// extracted by mini-css-extract-plugin
export default {"logoRow":"OrganisationDetailsPage_logoRow__DXl0X","buttonRow":"OrganisationDetailsPage_buttonRow__m5sze"};